import { ReceiptFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { ReceiptDraftRuleCreateFormProps } from "models/propTypes/receiptPropTypes";
import { forwardRef, ForwardRefRenderFunction, useEffect, useState } from "react";
import {
  ReceiptDraftCreateSection,
  useCreateReceiptDraftFormHelpers,
  useReceiptDraftFormValidation,
} from "components/automationRule/forms/receiptDraft";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import * as Yup from "yup";
import { useWintForm, WintForm } from "components/common/wintForms";
import { useCurrencyService } from "serviceHooks";
import { CurrencyEnums } from "models/enums";

const AutomationRuleCreateForm: ForwardRefRenderFunction<FormHandles, ReceiptDraftRuleCreateFormProps> = (
  props,
  ref
) => {
  const { receipt } = props;
  const { receiptCategories } = useCreateReceiptDraftFormHelpers();
  const { receiptDraftValidationScheme } = useReceiptDraftFormValidation();
  const { getExchangeRate } = useCurrencyService();

  const [amountInSek, setAmountInSek] = useState<number | undefined>(undefined);

  useEffect(() => {
    const convertAmount = async () => {
      try {
        let amountToRound = receipt.amount;
        if (receipt.currency !== CurrencyEnums.CurrencyCode.SEK) {
          const exchangeRate = await getExchangeRate(
            receipt.currency ?? CurrencyEnums.CurrencyCode.SEK,
            receipt.dateTime
          );
          amountToRound = receipt.amount * exchangeRate;
        }
        const roundedConvertedAmount = getRoundedMaxAmount(amountToRound);
        setAmountInSek(roundedConvertedAmount);
      } catch (error) {
        setAmountInSek(undefined);
      }
    };

    const getRoundedMaxAmount = (amount: number) => {
      const bufferedAmount = amount * 1.1;
      const roundedAmount = Math.ceil(bufferedAmount / 100) * 100;
      return roundedAmount;
    };

    convertAmount();
  }, [receipt.amount, receipt.currency, receipt.dateTime]);

  const initailValues: ReceiptFormTypes.AutomationRuleCreate = {
    receiptDraft: {
      category: receiptCategories?.find((c) => c.id === receipt.receiptCategoryId),
      paymentMethodId: receipt.paymentMethodId,
      supplier: { value: receipt.supplierName } as AutocompleteListItem,
      maximumAmount: amountInSek,
      isActive: true,
    },
  };

  const validationSchema = Yup.object<ReceiptFormTypes.AutomationRuleCreate>({
    receiptDraft: receiptDraftValidationScheme,
  });

  const { wintFormProps, connect } = useWintForm<ReceiptFormTypes.AutomationRuleCreate>({
    formRef: ref,
    defaultValues: initailValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  return (
    <WintForm {...wintFormProps}>
      <ReceiptDraftCreateSection connect={connect} isTodo receiptAmount={receipt.amount} currency={receipt.currency} />
    </WintForm>
  );
};

export default forwardRef(AutomationRuleCreateForm);
